import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { DataRoomModalType } from '../../enums/data-room-modal-type.enum';
import { useDeleteWorkspace } from '../../hooks/use-delete-workspace.hook';
import { useWorkspace } from '../../hooks/use-workspace.hook';
import { DataRoomModalStore } from '../../store/data-room-modal.store';
import { ConfirmDeleteModal } from './confirm-delete-modal';

export const DeleteWorkspaceModal: FC = () => {
  const isOpen = DataRoomModalStore(({ isOpen }) => isOpen);
  const type = DataRoomModalStore(({ type }) => type);
  const workspaceId = DataRoomModalStore(({ metadata }) => metadata?.spaceId);
  const handleAccept = DataRoomModalStore(({ handleAccept }) => handleAccept);
  const handleDismiss = DataRoomModalStore(({ handleDismiss }) => handleDismiss);
  const { workspace } = useWorkspace(workspaceId);
  const { deleteWorkspace, isPending } = useDeleteWorkspace({ onSuccess: handleAccept });

  if (type !== DataRoomModalType.DELETE_WORKSPACE || !workspaceId) {
    return null;
  }

  return (
    <ConfirmDeleteModal
      body={
        <AppFormattedMessage
          id="DELETE_WORKSPACE_CONFIRMATION"
          values={{ name: workspace?.name ?? '' }}
        />
      }
      isOpen={isOpen}
      isPending={isPending}
      onCancel={handleDismiss}
      onConfirm={() => deleteWorkspace({ id: workspaceId })}
      title={<AppFormattedMessage id="DELETE_INTERNAL_WORKSPACE_TITLE" />}
    />
  );
};
